import { render, staticRenderFns } from "./CustomerComplaintInvestigation.vue?vue&type=template&id=5f4a9f60&"
import script from "./CustomerComplaintInvestigation.vue?vue&type=script&lang=js&"
export * from "./CustomerComplaintInvestigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports